"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseApplicationOut = void 0;
class ListResponseApplicationOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseApplicationOut.attributeTypeMap;
    }
}
exports.ListResponseApplicationOut = ListResponseApplicationOut;
ListResponseApplicationOut.discriminator = undefined;
ListResponseApplicationOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ApplicationOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseApplicationOut.js.map